export default __webpack_public_path__ + "static/media/bg3.b120ea9e.jpg";